
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div className='left'><h4>Der R0-Wert</h4>
      <Image file={require('images/grafx_r0.png')} mdxType="Image" />
    </div>
    <div className='right'>
      <p>{`  Jedes Virus hat einen anderen R0-Wert (R-Null-Wert), auch
Basisreproduktionszahl genannt. Er zeigt an, wie viele Menschen ein einzelner
­Erkrankter in einer Gesellschaft anstecken kann, in der niemand gegen den
Erreger immun ist. Beim R0-Wert handelt es sich um einen Durchschnittswert.
Manche Personen sind ansteckender als andere. Ein Wert von 2 bedeutet
grundsätzlich, dass jeder Erkrankte das Virus an zwei andere Menschen
weitergibt. Es kann aber auch sein, dass ein sogenannter «super-spreader» 100
Menschen ansteckt und die restlichen 49 Erkrankten gar niemanden.`}</p>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;